
import React, { useState, useRef, useEffect,useMemo,} from "react";
import {
  Card,
  Table,
  Dropdown,
  Form,
  InputGroup,
} from "react-bootstrap";

import {
  FiCalendar,
  FiChevronDown,
  FiEdit2,
  FiTrash2,
  FiSearch,
} from "react-icons/fi";

import DeleteEmployeeSalModal from "../../../components/modals/financial&accounts/payroll/DeleteEmployeeSalModal";
import EditSalaryModal from "../../../components/modals/financial&accounts/payroll/EditSalaryModal";
import EmployeeSalaryHeader from "../../../components/financial&accounts/payroll/EmployeeSalaryHeader";
import { FaEdit } from "react-icons/fa";

// import AddSalaryModal from "./AddSalaryModal";
// import DeleteModal from "./DeleteModal";


const salaryData = [
  {
    id: 1,
    empId: "Emp-001",
    name: "Anthony Lewis",
    role: "Finance",
    email: "[email protected]",
    phone: "(123) 4567 890",
    designation: "Finance",
    joinDate: "12 Sep 2024",
    salary: "$40000",
    image: "/assets/img/users/user-32-1.jpg",
  },
  {
    id: 2,
    empId: "Emp-002",
    name: "Brian Villalobos",
    role: "Developer",
    email: "[email protected]",
    phone: "(179) 7382 829",
    designation: "Developer",
    joinDate: "24 Oct 2024",
    salary: "$35000",
    image: "/assets/img/users/user-09.jpg",
  },
  {
    id: 3,
    empId: "Emp-003",
    name: "Harvey Smith",
    role: "Executive",
    email: "[email protected]",
    phone: "(184) 2719 738",
    designation: "Executive",
    joinDate: "18 Feb 2024",
    salary: "$20000",
    image: "/assets/img/users/user-01-1.jpg",
  },
  {
    id: 4,
    empId: "Emp-004",
    name: "Stephan Peralt",
    role: "Executive Officer",
    email: "[email protected]",
    phone: "(193) 7839 748",
    designation: "Executive",
    joinDate: "17 Oct 2024",
    salary: "$22000",
    image: "/assets/img/users/user-33-1.jpg",
  },
  {
    id: 5,
    empId: "Emp-005",
    name: "Doglas Martini",
    role: "Manager",
    email: "[email protected]",
    phone: "(183) 9302 890",
    designation: "Manager",
    joinDate: "20 Jul 2024",
    salary: "$25000",
    image: "/assets/img/users/user-34.jpg",
  },
];

export default function EmployeeSalary() {
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [designationFilter, setDesignationFilter] =
    useState("Designation");

  const [sortBy, setSortBy] = useState("Last 7 Days");

  const [showEditModal, setShowEditModal] = useState(false);

  const [showDeleteModal, setShowDeleteModal] =
    useState(false);

  const [selectedEmployee, setSelectedEmployee] =
    useState(null);

  const filteredData = useMemo(() => {
    let data = [...salaryData];

    if (designationFilter !== "Designation") {
      data = data.filter(
        (item) =>
          item.designation === designationFilter
      );
    }

    if (search) {
      data = data.filter((item) =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    }

    return data.slice(0, rowsPerPage);
  }, [search, rowsPerPage, designationFilter]);

  const handleEdit = (employee) => {
    setSelectedEmployee(employee);
    setShowEditModal(true);
  };
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeRange, setActiveRange] = useState("Last 7 Days");
  const containerRef = useRef();

  const rangeOptions = [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "This Year",
    "Next Year",
    "Custom Range"
  ];

  // close dropdown
  useEffect(() => {
    const handleOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("click", handleOutside);
    return () => document.removeEventListener("click", handleOutside);
  }, []);

  // format date
  const formatDateValue = (date) =>
    date.toLocaleDateString("en-GB");

  // generate date range text
  const generateRangeLabel = () => {
    const today = new Date();
    let start = new Date();

    switch (activeRange) {
      case "Today":
        return `${formatDateValue(today)} - ${formatDateValue(today)}`;

      case "Yesterday":
        start.setDate(today.getDate() - 1);
        return `${formatDateValue(start)} - ${formatDateValue(start)}`;

      case "Last 7 Days":
        start.setDate(today.getDate() - 7);
        return `${formatDateValue(start)} - ${formatDateValue(today)}`;

      case "Last 30 Days":
        start.setDate(today.getDate() - 30);
        return `${formatDateValue(start)} - ${formatDateValue(today)}`;

      case "This Year":
        start = new Date(today.getFullYear(), 0, 1);
        return `${formatDateValue(start)} - ${formatDateValue(today)}`;

      case "Next Year":
        const nextStart = new Date(today.getFullYear() + 1, 0, 1);
        const nextEnd = new Date(today.getFullYear() + 1, 11, 31);
        return `${formatDateValue(nextStart)} - ${formatDateValue(nextEnd)}`;

      default:
        return "Custom Range";
    }
  };

  // select handler
  const handleRangeChange = (item) => {
    setActiveRange(item);
    setIsMenuOpen(false);
  };
  return (
    <>
  <div  style={{ padding: "15px", background: "#f8f9fa",  }}  >
<EmployeeSalaryHeader/>
         <Card className="salary-table-wrapper border-0">
        <Card.Header className="salary-card-header">
          <h5 className="salary-title">
            Employee Salary List
          </h5>

          <div className="salary-header-actions">
            {/* Date */}
       <div ref={containerRef} style={{ position: "relative", width: 240 }}>

      {/* TOP INPUT */}
      <div
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        style={{
          border: "1px solid #e5e7eb",
          padding: "10px 12px",
          borderRadius: 8,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          background: "#fff",
          fontSize: 14
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <FiCalendar />
          {generateRangeLabel()}
        </div>
        <FiChevronDown />
      </div>

      {/* DROPDOWN LIST */}
      {isMenuOpen && (
        <div
          style={{
            position: "absolute",
            top: "105%",
            left: 0,
            width: "100%",
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            padding: "8px 0",
            zIndex: 1000
          }}
        >
          {rangeOptions.map((item, idx) => (
            <div
              key={idx}
              onClick={() => handleRangeChange(item)}
              style={{
                padding: "12px 16px",
                fontSize: 14,
                cursor: "pointer",
                background:
                  activeRange === item ? "#ff6b00" : "transparent",
                color:
                  activeRange === item ? "#fff" : "#111827"
              }}
              onMouseEnter={(e) => {
                if (activeRange !== item)
                  e.currentTarget.style.background = "#f3f4f6";
              }}
              onMouseLeave={(e) => {
                if (activeRange !== item)
                  e.currentTarget.style.background = "transparent";
              }}
            >
              {item}
            </div>
          ))}
        </div>
      )}


    </div>


            {/* Designation */}
            <Dropdown>
              <Dropdown.Toggle className="salary-filter-btn">
                {designationFilter}
                <FiChevronDown />
              </Dropdown.Toggle>

              <Dropdown.Menu align="end">
                <Dropdown.Item
                  onClick={() =>
                    setDesignationFilter("Finance")
                  }
                >
                  Finance
                </Dropdown.Item>

                <Dropdown.Item
                  onClick={() =>
                    setDesignationFilter("Developer")
                  }
                >
                  Developer
                </Dropdown.Item>

                <Dropdown.Item
                  onClick={() =>
                    setDesignationFilter("Executive")
                  }
                >
                  Executive
                </Dropdown.Item>

                <Dropdown.Item
                  onClick={() =>
                    setDesignationFilter("Manager")
                  }
                >
                  Manager
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* Sort */}
            <Dropdown>
              <Dropdown.Toggle className="salary-filter-btn">
                Sort By : {sortBy}
                <FiChevronDown />
              </Dropdown.Toggle>

              <Dropdown.Menu align="end">
                <Dropdown.Item
                  onClick={() =>
                    setSortBy("Recently Added")
                  }
                >
                  Recently Added
                </Dropdown.Item>

                <Dropdown.Item
                  onClick={() =>
                    setSortBy("Ascending")
                  }
                >
                  Ascending
                </Dropdown.Item>

                <Dropdown.Item
                  onClick={() =>
                    setSortBy("Descending")
                  }
                >
                  Descending
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Card.Header>

        {/* Table Top */}
        <div className="salary-table-top">
          <div className="salary-row-select">
            <span>Row Per Page</span>

            <Form.Select
              value={rowsPerPage}
              onChange={(e) =>
                setRowsPerPage(Number(e.target.value))
              }
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
            </Form.Select>

            <span>Entries</span>
          </div>

          <InputGroup className="salary-search-box">
            <InputGroup.Text>
              <FiSearch />
            </InputGroup.Text>

            <Form.Control
              placeholder="Search"
              value={search}
              onChange={(e) =>
                setSearch(e.target.value)
              }
            />
          </InputGroup>
        </div>

        {/* Table */}
        <div className="table-responsive">
          <Table className="salary-table align-middle">
            <thead>
              <tr>
                <th>
                  <Form.Check />
                </th>

                <th>Emp ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Designation</th>
                <th>Joining Date</th>
                <th>Salary</th>
                <th>Payslip</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {filteredData.map((employee) => (
                <tr key={employee.id}>
                  <td>
                    <Form.Check />
                  </td>

                  <td>{employee.empId}</td>

                  <td>
                    <div className="salary-user-info">
                      <img
                        src={employee.image}
                        alt=""
                      />

                      <div>
                        <h6>{employee.name}</h6>
                        <span>{employee.role}</span>
                      </div>
                    </div>
                  </td>

                  <td>{employee.email}</td>

                  <td>{employee.phone}</td>

                  <td>
                    <Form.Select className="designation-select">
                      <option>
                        {employee.designation}
                      </option>

                      <option>Finance</option>
                      <option>Developer</option>
                      <option>Executive</option>
                      <option>Manager</option>
                    </Form.Select>
                  </td>

                  <td>{employee.joinDate}</td>

                  <td>{employee.salary}</td>

                  <td>
                    <button className="generate-slip-btn">
                      Generate Slip
                    </button>
                  </td>

                  <td>
                    <div className="salary-action-icons">
                      {/* <button
                        onClick={() =>
                          handleEdit(employee)
                        }
                      >
                        <FiEdit2 />
                      </button> */}
                      <FaEdit
    style={{
      cursor: "pointer",
      color: "#666d75", // light gray
      fontSize: "14px",
    }}
              onClick={() =>
                          handleEdit(employee)
                        }
  />
                      
                      <button
                        onClick={() =>
                          setShowDeleteModal(true)
                        }
                      >
                        <FiTrash2 />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card>

      {/* Edit Modal */}
      <EditSalaryModal
        show={showEditModal}
        handleClose={() =>
          setShowEditModal(false)
        }
        editData={selectedEmployee}
      />

      {/* Delete Modal */}
      <DeleteEmployeeSalModal
        show={showDeleteModal}
        handleClose={() =>
          setShowDeleteModal(false)
        }
      />

      <style>
          {
               `
               .salary-table-wrapper {
border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;
box-shadow:0 2px 5px rgba(0,0,0,0.05);
}

.salary-card-header {
  padding: 18px 20px;
  background: white;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.salary-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e2b4d;
  margin: 0;
}

.salary-header-actions {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.salary-date-box {
  height: 42px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: white;
  font-size: 14px;
}

.salary-filter-btn {
  background: white !important;
  border: 1px solid #e5e7eb !important;
  color: #111827 !important;
  height: 42px;
  border-radius: 6px !important;
  display: flex !important;
  align-items: center;
  gap: 8px;
}

.salary-table-top {
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
}

.salary-row-select {
  display: flex;
  align-items: center;
  gap: 5px;
}

.salary-row-select select {
  width: 80px;
}

.salary-search-box {
  width: 280px;
}

.salary-search-box input {
  height: 42px;
}

.salary-table thead {
  background: #f9fafb;
}

.salary-table thead th {
  font-size: 14px;
  color: #111827;
  font-weight: 700;
  padding: 16px;
  white-space: nowrap;
}

.salary-table tbody td {
  padding: 14px 16px;
  vertical-align: middle;
}

.salary-user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.salary-user-info img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
}

.salary-user-info h6 {
  font-size: 15px;
  margin-bottom: 2px;
}

.salary-user-info span {
  font-size: 13px;
  color: #6b7280;
}

.designation-select {
  min-width: 120px;
  height: 40px;
}

.generate-slip-btn {
  border: none;
  background: #111827;
  color: white;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
}

.salary-action-icons {
  display: flex;
  align-items: center;
  gap: 10px;
}

.salary-action-icons button {
  border: none;
  background: transparent;
  color: #6b7280;
  font-size: 18px;
}

/* Delete Modal */

.delete-modal-wrapper .modal-content {
  border: none;
  border-radius: 10px;
}

.delete-modal-body {
  text-align: center;
  padding: 34px;
}

.delete-icon-box {
  width: 58px;
  height: 58px;
  background: #fee2e2;
  color: red;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin: 0 auto 20px;
}

.delete-modal-body h3 {
  font-size: 32px;
  font-weight: 700;
  color: #1e2b4d;
  margin-bottom: 10px;
}

.delete-modal-body p {
  color: #4b5563;
  font-size: 16px;
  max-width: 320px;
  margin: auto;
}

.delete-modal-actions {
  display: flex;
  justify-content: center;
  gap: 14px;
  margin-top: 28px;
}

.delete-cancel-btn {
  border: 1px solid #d1d5db;
  background: white;
  padding: 10px 24px;
  border-radius: 8px;
}

.delete-confirm-btn {
  border: none;
  background: red;
  color: white;
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 600;
}

/* Responsive */

@media (max-width: 991px) {
  .salary-card-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .salary-header-actions {
    width: 100%;
  }

  .salary-search-box {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .salary-title {
    font-size: 22px;
  }

  .salary-table-top {
    flex-direction: column;
    align-items: stretch;
  }

  .salary-row-select {
    width: 100%;
    justify-content: space-between;
  }

  .salary-date-box,
  .salary-filter-btn {
    width: 100%;
    justify-content: space-between;
  }

  .salary-header-actions {
    flex-direction: column;
    width: 100%;
  }
}
        
/* MOBILE FIX ONLY */
@media (max-width: 768px) {
  .salary-header-actions {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-top: 12px;
  }

  .salary-header-actions > * {
    width: 100%;
  }

  .salary-header-actions .dropdown {
    width: 100%;
  }

  .salary-header-actions .dropdown-toggle {
    width: 100%;
    height: 48px;
    justify-content: space-between;
    padding: 0 14px;
    font-size: 14px;
  }

  .salary-date-box {
    width: 100% !important;
  }

  .salary-filter-btn {
    width: 100% !important;
    display: flex !important;
    align-items: center;
    justify-content: space-between;
  }
}       `
          }
      </style>
  </div>
    </>
  );
}